import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 10vh;
  padding: 1em;
`;
export const Icons = styled.div`
  margin: 0;

  i {
    font-size: 1em;
    color: orange;
  }
`;
export const H1 = styled.h4`
  margin: 0;
`;
